

export const DATA_TABLE_ALIGN_HORIZONTAL = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
};